// Ulkoasut (teemat). Jokainen ulkoasu on oma värien, kirjasimien ja muotojen kokonaisuus,
// jonka styles-skins.css määrittelee <html data-skin="..."> -valitsimella. Oletusulkoasu
// (Suunnistus) ei aseta attribuuttia, ja sen vaalea/tumma-valinta toimii kuten ennen.

export const DEFAULT_SKIN = "suunnistus";

/** Valintalista asetuksiin. `chrome` on järjestelmän yläpalkin väri (meta theme-color). */
export const SKINS = [
  { id: "suunnistus", label: "Suunnistus", about: "Suunnistuskartan värit. Vaalea tai tumma valittavissa.", chrome: "#1e3a2a", dark: null },
  { id: "vanha", label: "Vanha kartta", about: "Pergamenttia, ruskeaa mustetta ja serif-kirjasin.", chrome: "#3b2a18", dark: false },
  { id: "arcade", label: "Arcade", about: "Pelimäinen: tumma pohja, neonvärit ja paksut reunat.", chrome: "#14122b", dark: true },
  { id: "aurora", label: "Aurora", about: "Revontulitaivas ja himmeä lasi.", chrome: "#0b1630", dark: true },
  { id: "kontrasti", label: "Suurkontrasti", about: "Musta, keltainen ja valkoinen. Isot napit, luettava auringossa.", chrome: "#000000", dark: false },
  { id: "retro", label: "Retro-terminaali", about: "Vihreä fosfori mustalla ja tekstipohjaiset napit.", chrome: "#04110a", dark: true },
];

/** Tuntematon tai puuttuva arvo (vanha tallennus, poistettu ulkoasu) palaa oletukseen. */
export function normalizeSkin(id) {
  return SKINS.some((s) => s.id === id) ? id : DEFAULT_SKIN;
}

export function skinById(id) {
  return SKINS.find((s) => s.id === normalizeSkin(id));
}

/** Vaalea/tumma-valinta koskee vain oletusulkoasua; muilla ulkoasuilla on oma kiinteä paletti. */
export function themeApplies(id) {
  return normalizeSkin(id) === DEFAULT_SKIN;
}
